<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
  >
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="dropdown_lrg"
        transform="translate(-312.000000, -15.000000)"
        fill="#7d8b96"
      >
        <!-- eslint-disable-next-line -->
        <polygon id="Shape" transform="translate(321.000000, 30.250000) rotate(270.000000) translate(-321.000000, -30.250000) " points="327.9 25 321 31.527027 314.1 25 312 26.9864865 321 35.5 330 26.9864865"></polygon>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'RareIconLeftArrow',
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  svg:hover g {
    cursor: pointer;
    fill: #323c44;
  }

  svg:hover {
    cursor: pointer;
  }

</style>
